import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, tap, of, switchMap, forkJoin } from 'rxjs';
import { environment } from '../../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class OrdemServicoService {
    private apiUrl = `${environment.cedaeapp}/ordemservico`;

    constructor(private http: HttpClient) { }

    naoAtribuidos(
        pagina?: number,
        tamanhoPagina?: number,
        nomeConsumidor?: string,
        cpf?: string,
        matricula?: string,
        status?: string,
        cep?: string,
        logradouro?: string,
        bairro?: string,
        cidade?: string,
        estado?: string,
        numero?: string,
        numeroOS?: string,
        statusOS?: string,
        ordenarPor?: number,
        direcao?: number
    ): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        let params = new HttpParams();
        if (pagina !== undefined && pagina !== null) {
            params = params.set('Pagina', String(pagina));
        }
        if (tamanhoPagina !== undefined && tamanhoPagina !== null) {
            params = params.set('TamanhoPagina', String(tamanhoPagina));
        }

        if (nomeConsumidor?.trim()) params = params.set('nomeConsumidor', nomeConsumidor.trim());
        if (cpf?.trim()) params = params.set('CPF', cpf.trim());
        if (matricula?.trim()) params = params.set('Matricula', matricula.trim());
        if (status?.trim()) params = params.set('Status', status.trim());

        // 🔹 Novos filtros de endereço
        if (cep?.trim()) params = params.set('Cep', cep.trim());
        if (logradouro?.trim()) params = params.set('Logradouro', logradouro.trim());
        if (bairro?.trim()) params = params.set('Bairro', bairro.trim());
        if (cidade?.trim()) params = params.set('Cidade', cidade.trim());
        if (estado?.trim()) params = params.set('Estado', estado.trim());
        if (numero?.trim()) params = params.set('Numero', numero.trim());
        if (numeroOS?.trim()) params = params.set('NumeroOS', numeroOS.trim());
        if (statusOS?.trim()) params = params.set('StatusOS', statusOS.trim());

        // Ordenação (opcional) - usa os enums do backend como inteiros
        // OrdenarPor: 0=NomeConsumidor,1=Logradouro,2=Bairro,3=Cidade,4=NumeroEndereco,5=Vistoria
        // direcao: 0=Asc,1=Desc
        if (ordenarPor !== undefined && ordenarPor !== null) {
            params = params.set('OrdenarPor', String(ordenarPor));
        }
        if (direcao !== undefined && direcao !== null) {
            params = params.set('direcao', String(direcao));
        }

        const url = `${environment.cedaeapp}/buscasdetalhadas/nao-atribuídos`;

        return this.http.get<any>(url, { headers, params }).pipe(
            tap(response => {
            }),
            map(response => {
                if (!response || !response.itens) {
                    console.warn('Resposta da API não contém propriedade itens:', response);
                    return { itens: [], totalItens: 0, paginaAtual: pagina, totalPaginas: 0, tamanhoPagina };
                }
                return response;
            }),
            catchError(err => {
                console.error('❌ Erro ao buscar registros mais recentes:', err);
                throw err;
            })
        );
    }

    consultarTodosMaisRecentes(
        pagina: number = 1,
        tamanhoPagina: number = 10,
        nome?: string,
        cpf?: string,
        matricula?: string,
        status: string = 'Pendente',
        cep?: string,
        logradouro?: string,
        bairro?: string,
        cidade?: string,
        estado?: string
    ): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        let params = new HttpParams()
            .set('Pagina', pagina.toString())
            .set('TamanhoPagina', tamanhoPagina.toString());

        if (nome?.trim()) params = params.set('Nome', nome.trim());
        if (cpf?.trim()) params = params.set('CPF', cpf.trim());
        if (matricula?.trim()) params = params.set('Matricula', matricula.trim());
        if (status?.trim()) params = params.set('Status', status.trim());

        // 🔹 Novos filtros de endereço
        if (cep?.trim()) params = params.set('Cep', cep.trim());
        if (logradouro?.trim()) params = params.set('Logradouro', logradouro.trim());
        if (bairro?.trim()) params = params.set('Bairro', bairro.trim());
        if (cidade?.trim()) params = params.set('Cidade', cidade.trim());
        if (estado?.trim()) params = params.set('Estado', estado.trim());

        const url = `${environment.cedaeapp}/buscasdetalhadas/todos-mais-recentes`;

        return this.http.get<any>(url, { headers, params }).pipe(
            tap(response => {
            }),
            map(response => {
                if (!response || !response.itens) {
                    console.warn('Resposta da API não contém propriedade itens:', response);
                    return { itens: [], totalItens: 0, paginaAtual: pagina, totalPaginas: 0, tamanhoPagina };
                }
                return response;
            }),
            catchError(err => {
                console.error('❌ Erro ao buscar registros mais recentes:', err);
                throw err;
            })
        );
    }

    /**
     * Distribui uma ordem de serviço para um usuário, cadastro e recadastro.
     * @param usuarioId string (uuid)
     * @param cadastroId string (uuid)
     * @param recadastroId string (uuid)
     */
    distribuirOrdemServico(usuarioId: string, cadastroId: string, recadastroId: string, ordemServicoId?: string, matricula?: string, status?: string, statusOS?: string): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });
        let params = new HttpParams();
        if (usuarioId) params = params.set('usuarioId', usuarioId);

        // Normalize inputs
        const isRecadastroIdZero = recadastroId === '00000000-0000-0000-0000-000000000000';
        const cadId = cadastroId && cadastroId !== '00000000-0000-0000-0000-000000000000' ? cadastroId : null;
        
        // Build request body based on specific business rules
        let body: any = {
            usuarioId: usuarioId || null
        };

        // NOVA REGRA: Se recadastroId está preenchido e não é zero, enviar payload de recadastro simples
        if (recadastroId && !isRecadastroIdZero) {
            body = {
                usuarioId: usuarioId,
                isRecadastro: true,
                recadastroId: recadastroId,
                osAnteriorId: ordemServicoId || null
            };
        }
        // Regra 1: Status "Pendente" com recadastroId zerado
        else if (status === 'Pendente' && isRecadastroIdZero) {
            body.cadastroId = cadId;
            body.isRecadastro = true;
        }
        // Regra 2: Status "Ausente" e statusOS "Retornar"  
        else if (status === 'Ausente' && statusOS === 'Retornar') {
            body.cadastroId = cadId;
            body.isRecadastro = true;
            body.osAnteriorId = ordemServicoId || null;
        }
        else {
            const hasMatricula = !!(matricula && matricula.toString().trim());
            const recId = recadastroId && !isRecadastroIdZero ? recadastroId : null;
            
            let effectiveCadastroId: string | null = null;
            let effectiveRecadastroId: string | null = null;
            let isRecadastro: boolean = true; // default

            if (hasMatricula && recId) {
                effectiveRecadastroId = recId;
                effectiveCadastroId = null;
                isRecadastro = false;
            } else if (!hasMatricula && (status === 'Ausente' || statusOS === 'Retornar')) {
                effectiveCadastroId = cadId;
                effectiveRecadastroId = null;
                isRecadastro = false;
            } else if ((status === 'Pendente' || statusOS === 'Pendente' || statusOS === 'Concluido') && !recId) {
                effectiveCadastroId = cadId;
                effectiveRecadastroId = null;
                isRecadastro = true;
            } else {
                if (recId) {
                    effectiveRecadastroId = recId;
                    effectiveCadastroId = null;
                    isRecadastro = false;
                } else {
                    effectiveCadastroId = cadId;
                    effectiveRecadastroId = null;
                    isRecadastro = true;
                }
            }

            body.cadastroId = effectiveCadastroId;
            body.recadastroId = effectiveRecadastroId;
            body.isRecadastro = isRecadastro;
            body.ordemServicoId = ordemServicoId || null;

            // Set query params for original logic
            if (effectiveCadastroId) params = params.set('cadastroId', effectiveCadastroId);
            if (effectiveRecadastroId) params = params.set('recadastroId', effectiveRecadastroId);
        }
        const url = `${this.apiUrl}/distribuir`;
        return this.http.post<any>(url, body, { headers, params }).pipe(
            tap(response => {
                console.log('✅ Vistoria distribuída:', response);
            }),
            switchMap(response => {
                const tasks: Observable<any>[] = [];
                
                // Se é um recadastro simples (nova regra), não fazer chamadas adicionais
                if (recadastroId && !isRecadastroIdZero) {
                    return of(response);
                }
                
                // Para os casos específicos das regras de negócio
                if ((status === 'Pendente' && isRecadastroIdZero) || (status === 'Ausente' && statusOS === 'Retornar')) {
                    if (body.cadastroId) {
                        tasks.push(this.atribuirCadastro(body.cadastroId, true));
                    }
                } else {
                    // Para a lógica original
                    if (body.cadastroId) tasks.push(this.atribuirCadastro(body.cadastroId, true));
                    if (body.recadastroId) tasks.push(this.atribuirRecadastro(body.recadastroId, true));
                }
                
                if (tasks.length > 0) {
                    return forkJoin(tasks).pipe(
                        map(() => response)
                    );
                }
                return of(response);
            }),
            catchError(err => {
                console.error('❌ Erro ao distribuir vistoria:', err);
                return of(null);
            })
        );
    }

    /**
     * Reatribui uma ordem de serviço para outro usuário
     * @param id string (uuid) - id da ordem de serviço
     * @param novoUsuarioId string (uuid) - id do novo usuário
     */
    reatribuirOrdemServico(id: string, novoUsuarioId: string): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        let params = new HttpParams();
        if (novoUsuarioId) params = params.set('novoUsuarioId', novoUsuarioId);

        const url = `${this.apiUrl}/${id}/reatribuir`;
        return this.http.put<any>(url, null, { headers, params }).pipe(
            tap(response => {
                console.log(`✅ Vistoria ${id} reatribuída para usuário ${novoUsuarioId}:`, response);
            }),
            catchError(err => {
                console.error('❌ Erro ao reatribuir vistoria:', err);
                return of(null);
            })
        );
    }

    /**
     * Desatribui uma ordem de serviço (remove usuário e atualiza cadastro/recadastro para não atribuído)
     * @param id string (uuid) - id da ordem de serviço
     */
    desatribuirOrdemServico(id: string): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        // Primeiro obtém os detalhes da ordem para pegar os IDs de cadastro/recadastro
        return this.getOrdemServicoById(id).pipe(
            switchMap(ordem => {
                if (!ordem) {
                    console.warn(`❗ Não foi possível obter detalhes da ordem ${id} para desatribuição`);
                    return of(null);
                }

                // Extrai os IDs considerando diferentes formatos da API
                const cadastroId = ordem.cadastroId || ordem.CadastroId ||
                    (ordem.Cadastro && (ordem.Cadastro.id || ordem.Cadastro.cadastroId)) ||
                    (ordem.cadastro && (ordem.cadastro.id || ordem.cadastro.cadastroId));

                const recadastroId = ordem.recadastroId || ordem.RecadastroId ||
                    (ordem.Recadastro && (ordem.Recadastro.id || ordem.Recadastro.recadastroId)) ||
                    (ordem.recadastro && (ordem.recadastro.id || ordem.recadastro.recadastroId));

                const tasks: Observable<any>[] = [];

                // Desatribui o cadastro se existir
                if (cadastroId) {
                    tasks.push(this.atribuirCadastro(cadastroId, false));
                }

                // Desatribui o recadastro se existir
                if (recadastroId) {
                    tasks.push(this.atribuirRecadastro(recadastroId, false));
                }

                // Remover usuário da ordem usando o endpoint de reatribuição com usuarioId vazio/null
                const url = `${this.apiUrl}/${id}/reatribuir`;
                let params = new HttpParams().set('novoUsuarioId', '00000000-0000-0000-0000-000000000000');
                const desatribuirOrdem = this.http.put<any>(url, null, { headers, params }).pipe(
                    tap(response => console.log(`✅ Ordem ${id} desatribuída (usuário removido)`)),
                    catchError(err => {
                        console.error(`❌ Erro ao remover usuário da ordem ${id}:`, err);
                        return of(null);
                    })
                );
                tasks.push(desatribuirOrdem);

                // Se não tiver nenhuma tarefa, retorna null
                if (tasks.length === 0) {
                    return of(null);
                }

                // Executa todas as tarefas de desatribuição
                return forkJoin(tasks).pipe(
                    map(() => {
                        return { success: true, message: 'Ordem desatribuída com sucesso' };
                    }),
                    catchError(err => {
                        console.error(`❌ Erro ao desatribuir ordem ${id}:`, err);
                        return of(null);
                    })
                );
            }),
            catchError(err => {
                console.error(`❌ Erro ao buscar detalhes da ordem ${id} para desatribuição:`, err);
                return of(null);
            })
        );
    }

    /**
     * Busca detalhes de uma ordem de serviço por id
     * @param id string (uuid)
     */
    getOrdemServicoById(id: string): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<any>(url, { headers }).pipe(
            tap(response => console.log(`🔎 Detalhes ordem ${id}:`, response)),
            catchError(err => {
                console.error('❌ Erro ao buscar ordem por id:', err);
                return of(null);
            })
        );
    }
    /**
     * Altera o status da ordem de serviço (PUT /ordemservico/{id}/status)
     * @param id string (uuid) - id da ordem
     * @param status number - código do status (ex: 4 = Cancelada)
     */
    changeStatus(id: string, status: number): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });
        const url = `${this.apiUrl}/${id}/status`;
        // o endpoint espera o novo status no corpo (ex: 0,1,2...)

        // Verificar se é uma operação de cancelamento (status 3)
        if (status === 3) {
            // Primeiro obtém os detalhes da ordem para pegar os IDs de cadastro/recadastro
            return this.getOrdemServicoById(id).pipe(
                switchMap(ordem => {
                    if (!ordem) {
                        console.warn(`❗ Não foi possível obter detalhes da ordem ${id} para cancelamento`);
                        return of(null);
                    }

                    // Extrai os IDs considerando diferentes formatos da API
                    const cadastroId = ordem.cadastroId || ordem.CadastroId ||
                        (ordem.Cadastro && (ordem.Cadastro.id || ordem.Cadastro.cadastroId)) ||
                        (ordem.cadastro && (ordem.cadastro.id || ordem.cadastro.cadastroId));

                    const recadastroId = ordem.recadastroId || ordem.RecadastroId ||
                        (ordem.Recadastro && (ordem.Recadastro.id || ordem.Recadastro.recadastroId)) ||
                        (ordem.recadastro && (ordem.recadastro.id || ordem.recadastro.recadastroId));

                    // Faz a mudança de status da ordem
                    return this.http.put<any>(url, status, { headers }).pipe(
                        switchMap(response => {
                            if (!response) {
                                console.error(`❌ Falha ao atualizar status da ordem ${id}`);
                                return of(null);
                            }
                            const tasks: Observable<any>[] = [];

                            // Desatribui o cadastro se existir
                            if (cadastroId) {
                                tasks.push(this.atribuirCadastro(cadastroId, false));
                            }

                            // Desatribui o recadastro se existir
                            if (recadastroId) {
                                tasks.push(this.atribuirRecadastro(recadastroId, false));
                            }

                            // Se não tiver cadastro nem recadastro, retorna a resposta original
                            if (tasks.length === 0) {
                                return of(response);
                            }

                            // Executa todas as tarefas de desatribuição e retorna a resposta original
                            return forkJoin(tasks).pipe(
                                map(() => {
                                    console.log(`✅ Cadastro/Recadastro desatribuídos com sucesso após cancelamento da ordem ${id}`);
                                    return response;
                                }),
                                catchError(err => {
                                    console.error(`❌ Erro ao desatribuir cadastro/recadastro na ordem ${id}:`, err);
                                    // Mesmo com erro na desatribuição, retornamos success da operação principal
                                    return of(response);
                                })
                            );
                        }),
                        catchError(err => {
                            console.error(`❌ Erro ao alterar status da ordem ${id}:`, err);
                            console.error(`Detalhes da ordem: Cadastro=${cadastroId || 'não encontrado'}, Recadastro=${recadastroId || 'não encontrado'}`);
                            return of(null);
                        })
                    );
                }),
                catchError(err => {
                    console.error(`❌ Erro ao buscar detalhes da ordem ${id} para cancelamento:`, err);
                    return of(null);
                })
            );
        } else {
            // Para outros status, só altera o status da ordem normalmente
            return this.http.put<any>(url, status, { headers }).pipe(
                tap(response => console.log(`🔁 Status da ordem ${id} alterado para ${status}:`, response)),
                catchError(err => {
                    console.error('❌ Erro ao alterar status da ordem:', err);
                    return of(null);
                })
            );
        }
    }
    
    /**
     * Busca todas as ordens de serviço com filtros opcionais (GET /api/ordemservico)
     * @param dataInicial string - Data inicial no formato YYYY-MM-DD
     * @param dataFinal string - Data final no formato YYYY-MM-DD
     * @param status number - Status da ordem (0=Pendente, 1=EmAndamento, 2=Concluida, 3=Reatribuida, 4=Cancelada)
     * @param numeroOrdem number - Número da ordem
     * @param matricula string - Matrícula do consumidor
     * @param nomeConsumidor string - Nome do consumidor
     * @param pagina number - Página para paginação
     * @param tamanhoPagina number - Tamanho da página
     * @param usuarioId string - Filtro por usuário responsável
     */
    getOrdensServico(
        dataInicial?: string,
        dataFinal?: string,
        status?: number,
        numeroOrdem?: number,
        matricula?: string,
        nomeConsumidor?: string,
        usuarioId?: string,
        cpf?: string,
        cnpj?: string,
        cep?: string,
        logradouro?: string,
        bairro?: string,
        cidade?: string,
        estado?: string,
        numero?: string,
        pagina: number = 1,
        tamanhoPagina: number = 50
    ): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });

        let params = new HttpParams()
            .set('Pagina', pagina.toString())
            .set('TamanhoPagina', tamanhoPagina.toString());

        if (dataInicial?.trim()) params = params.set('DataInicial', dataInicial.trim());
        if (dataFinal?.trim()) params = params.set('DataFinal', dataFinal.trim());
        if (status !== undefined && status !== null) params = params.set('Status', status.toString());
        if (numeroOrdem !== undefined && numeroOrdem !== null) params = params.set('NumeroOrdem', numeroOrdem.toString());
        if (matricula?.trim()) params = params.set('Matricula', matricula.trim());
        if (nomeConsumidor?.trim()) params = params.set('NomeConsumidor', nomeConsumidor.trim());
        if (usuarioId?.trim()) params = params.set('UsuarioId', usuarioId.trim());

        // CPF / CNPJ
        if (cpf?.trim()) params = params.set('CPF', cpf.trim());
        if (cnpj?.trim()) params = params.set('CNPJ', cnpj.trim());

        // filtros de endereço
        if (cep?.trim()) params = params.set('Cep', cep.trim());
        if (logradouro?.trim()) params = params.set('Logradouro', logradouro.trim());
        if (bairro?.trim()) params = params.set('Bairro', bairro.trim());
        if (cidade?.trim()) params = params.set('Cidade', cidade.trim());
        if (estado?.trim()) params = params.set('Estado', estado.trim());
        if (numero?.trim()) params = params.set('Numero', numero.trim());

        const url = `${this.apiUrl}`;
        return this.http.get<any>(url, { headers, params }).pipe(
            tap(response => {
            }),
            map(response => {
                if (!response || !response.itens) {
                    console.warn('Resposta da API não contém propriedade itens:', response);
                    return { itens: [], totalItens: 0, paginaAtual: pagina, totalPaginas: 0, tamanhoPagina: 50 };
                }
                return response;
            }),
            catchError(err => {
                console.error('❌ Erro ao buscar ordens de serviço:', err);
                return of({ itens: [], totalItens: 0, paginaAtual: pagina, totalPaginas: 0, tamanhoPagina: 50 });
            })
        );
    }

    /**
     * Atribui (ou remove atribuição) de um cadastro no backend.
     * Endpoint: PATCH /cadastro/{cadastroId}/atribuir
     * @param cadastroId string (uuid)
     * @param atribuir boolean - true para atribuir, false para remover
     */
    atribuirCadastro(cadastroId: string, atribuir: boolean): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });
        let params = new HttpParams().set('atribuida', atribuir.toString());
        const url = `${environment.cedaeapp}/cadastro/${cadastroId}/atribuir`;

        return this.http.patch<any>(url, null, { headers, params }).pipe(
            tap(response => console.log(`✅ Atribuição cadastro ${cadastroId} para ${atribuir}:`, response)),
            catchError(err => {
                console.error(`❌ Erro ao ${atribuir ? 'atribuir' : 'desatribuir'} cadastro:`, err);
                return of(null);
            })
        );
    }

    /**
     * @param recadastroId string (uuid)
     * @param atribuir boolean - true para atribuir, false para remover
     */
    atribuirRecadastro(recadastroId: string, atribuir: boolean): Observable<any> {
        const token = localStorage.getItem('token');
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        });
        let params = new HttpParams().set('atribuida', atribuir.toString());
        const url = `${environment.cedaeapp}/recadastro/${recadastroId}/atribuir`;

        return this.http.patch<any>(url, null, { headers, params }).pipe(
            tap(response => console.log(`✅ Atribuição recadastro ${recadastroId} para ${atribuir}:`, response)),
            catchError(err => {
                console.error(`❌ Erro ao ${atribuir ? 'atribuir' : 'desatribuir'} recadastro:`, err);
                return of(null);
            })
        );
    }
}